import { apiUrl } from '../content/landingContent.js'

// Métodos de pagamento disponíveis no cadastro pago (ver backend
// GET /api/public/payment-options). Usado pelo TenantSignupModal pra decidir
// se mostra a opção "Pix" no passo de pagamento.
// `trialDays` = dias de teste grátis no cartão (0 = sem teste, cobra no ato).
// A resposta é reaproveitada: vários CTAs e o modal consultam o mesmo endpoint.
let cached = null

export function fetchPaymentOptions() {
  if (!cached) {
    cached = (async () => {
      try {
        const res = await fetch(`${apiUrl}/api/public/payment-options`)
        if (!res.ok) return { card: true, pix: false, trialDays: 0 }
        const data = await res.json()
        return { card: Boolean(data.card), pix: Boolean(data.pix), trialDays: Number(data.trial_days) || 0 }
      } catch {
        return { card: true, pix: false, trialDays: 0 }
      }
    })()
  }
  return cached
}
